// @flow

import { fromJS } from 'immutable';
import { loadOrder } from '../State/order';

export type RemoveOrderCaveatParams = {
  orderCaveatIndex: number
}

export default (params: RemoveOrderCaveatParams) => (dispatch: Function, getState: Function) => {

  let order = fromJS(getState().screens.OrderView.order);
  
  order = order.removeIn(['order_caveats', params.orderCaveatIndex]);

  order = order.toJS();
  
  dispatch(loadOrder(order));

}